'use client';

import { useQuery } from '@tanstack/react-query';
import Link from 'next/link';
import { useMemo } from 'react';

import { getImportantArticles } from '@/features/articles';
import { Text } from '@/shared/ui';
import { Slider } from '../Slider';
import { Article } from './Article';
import { Placeholder } from './Placeholder';
import styles from './MostRecent.module.css';

export const MostRecent = () => {
  const { data: articles } = useQuery(
    getImportantArticles({
      limit: 9,
    })
  );

  const { data: cardArticles } = useQuery(
    getImportantArticles({
      limit: 2,
      importance_level: 'secondary',
    })
  );

  const { data: heroArticles } = useQuery(
    getImportantArticles({
      limit: 1,
      importance_level: 'primary',
    })
  );
  const heroArticle = heroArticles?.[0];

  const tileArticles = useMemo(() => {
    return articles?.filter(
      (article) =>
        article.id !== heroArticle?.id &&
        cardArticles?.some((cardArticle) => cardArticle.id !== article.id)
    );
  }, [articles, cardArticles, heroArticle]);

  return (
    <>
      <div className={styles.container}>
        {heroArticle && (
          <Article
            className={styles.slide}
            article={heroArticle}
            key={heroArticle.id}
            type="hero"
          />
        )}
        <Slider
          className={styles.slider}
          header={
            <Link href="/recent">
              <Text className={styles.title} variant="secondary">
                Самое свежее
              </Text>
            </Link>
          }
        >
          {tileArticles?.map((article) => (
            <Article
              className={styles.slide}
              article={article}
              key={article.id}
              type="tile"
            />
          ))}
          <Link href="/recent">
            <Placeholder className={styles.slide} />
          </Link>
        </Slider>
        <div className={styles.cardList}>
          {cardArticles?.map((article) => (
            <Article
              className={styles.slide}
              article={article}
              key={article.id}
              type="card"
            />
          ))}
        </div>
      </div>
    </>
  );
};
